import { jsxs as h, jsx as l } from "react/jsx-runtime";
import n, { useEffect as I } from "react";
import i, { css as t } from "styled-components";
import { a as D, b as j, h as m, _ as A, i as B } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { a as S, R as C } from "../chunks/index.cff5baaf.js";
const F = i.div.withConfig({
  displayName: "RangoInputSelect",
  componentId: "sc-n55mhk-0"
})(["& *{margin:0;padding:0;}width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:var(--spacing-1x);@media screen and (min-width:768px){min-width:312px;}", ""], ({
  disabled: e
}) => e && t(["opacity:var(--disabled-opacity);pointer-events:none;"])), K = i.div.withConfig({
  displayName: "Element",
  componentId: "sc-n55mhk-1"
})(["width:100%;height:var(--size-8x);display:flex;flex-direction:column;justify-content:center;padding:var(--spacing-1x) var(--spacing-2x);box-sizing:border-box;background-color:transparent;border-radius:var(--default-border-radius);border:var(--default-border-width) solid var(--elements-border-color);gap:var(--spacing-1x);cursor:pointer;position:relative;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);&:hover{", " transition-timing-function:var(--curve-productive-entrance);border-color:transparent;}&:focus-within:not(:active){", " outline-offset:2px;border:var(--default-border-width) solid var(--active-border-color);}& select{", " width:100%;height:inherit;padding:inherit;border-radius:inherit;outline:none;border:none;background-color:transparent;cursor:inherit;color:var(--text-placeholder-color);position:absolute;z-index:1;left:0;opacity:0;-moz-appearance:none;-webkit-appearance:none;appearance:none;}", " ", " ", " ", ""], D, j, m, ({
  active: e
}) => e && t(["border:var(--default-border-width) solid var(--active-border-color);transition-property:all;transition-timing-function:var(--curve-productive-entrance);transition-duration:var(--duration-fast-02);"]), ({
  disabled: e
}) => e && t(["border:var(--default-border-width) solid var(--disabled-border-color);", "{color:var(--disabled-icon-color);}"], S), ({
  error: e
}) => e && t(["border:var(--default-border-width) solid var(--negative-border-color) !important;", "{color:var(--negative-icon-color);}"], S), ({
  $clicked: e
}) => e && t(["&:focus-within:not(:active){outline:transparent;}"])), P = i.label.withConfig({
  displayName: "Label",
  componentId: "sc-n55mhk-2"
})(["", " color:var(--text-label-color);", " ", " ", ""], A, ({
  $clicked: e
}) => e && t(["color:var(--active-label-color);"]), ({
  disabled: e
}) => e && t(["color:var(--disabled-label-color);"]), ({
  error: e
}) => e && t(["color:var(--negative-label-color);"])), T = i.select.withConfig({
  displayName: "Select",
  componentId: "sc-n55mhk-3"
})(["", " width:100%;height:inherit;padding:inherit;border-radius:inherit;outline:none;border:none;background-color:transparent;cursor:inherit;color:var(--text-placeholder-color);position:absolute;z-index:1;left:0;-moz-appearance:none;-webkit-appearance:none;appearance:none;&:disabled{color:var(--disabled-placeholder-color);}", " &::placeholder{color:var(--on-text-placeholder-color);}"], m, ({
  $filled: e
}) => e && t(["color:var(--active-placeholder-color) !important;"])), M = i.span.withConfig({
  displayName: "Placeholder",
  componentId: "sc-n55mhk-4"
})(["", " color:var(--text-placeholder-color);", " ", " ", ""], m, ({
  $filled: e
}) => e && t(["color:var(--active-placeholder-color) !important;"]), ({
  disabled: e
}) => e && t(["color:var(--disabled-placeholder-color);"]), ({
  error: e
}) => e && t(["color:var(--negative-placeholder-color) !important;"])), q = i.div.withConfig({
  displayName: "Icons",
  componentId: "sc-n55mhk-5"
})(["position:absolute;top:20px;right:var(--spacing-2x);z-index:0;display:flex;gap:var(--spacing-1x);"]), G = i.p.withConfig({
  displayName: "SupportText",
  componentId: "sc-n55mhk-6"
})(["", " color:var(--text-support-text-color);", " ", ""], B, ({
  disabled: e
}) => e && t(["color:var(--disabled-support-text-color);"]), ({
  error: e
}) => e && t(["color:var(--negative-support-text-color);"])), H = n.forwardRef(({
  id: e = "",
  value: g = "",
  disabled: a = !1,
  hidden: J = !1,
  error: c = !1,
  label: R = "",
  placeholder: p = "",
  supportText: b = "",
  children: f,
  ...E
}, N) => {
  const [s, x] = n.useState(() => {
    const o = n.Children.toArray(f).find((r) => n.isValidElement(r) && r.props.selected);
    return o && n.isValidElement(o) ? o.props.value : p;
  }), [w, y] = n.useState(() => {
    const o = n.Children.toArray(f).find((r) => n.isValidElement(r) && r.props.selected);
    return o && n.isValidElement(o) ? o.props.children : p;
  }), [d, u] = n.useState(!1), [_, v] = n.useState(!1), k = n.useRef(null), L = () => {
    u(!1), v(!1);
  }, z = (o) => {
    const r = o.target.options[o.target.selectedIndex];
    x(o.target.value), y(r.text), u(!d), v(!1), o.target.blur();
  }, O = () => {
    u(!0);
  }, V = (o) => {
    const {
      key: r
    } = o;
    (r === " " || r === "Enter") && (u(!d), v(!0));
  };
  return I(() => {
    x(g);
  }, [g]), I(() => {
    const o = k.current, r = o.selectedIndex, $ = o.options[r].text;
    y($);
  }, [s]), /* @__PURE__ */ h(F, { disabled: a, ref: N, "data-rango-component": "rango-input-select", "data-is-rango": !0, ...E, children: [
    /* @__PURE__ */ l(P, { disabled: a, error: c && !a, value: s, $clicked: d, htmlFor: e, children: R }),
    /* @__PURE__ */ h(K, { active: d, disabled: a, error: c && !a, $clicked: d, onClick: O, children: [
      /* @__PURE__ */ h(T, { id: e, ref: k, $filled: s !== "", value: s, disabled: a, onBlur: L, onChange: z, onKeyDown: V, onFocus: () => v(!0), children: [
        /* @__PURE__ */ l("option", { value: "", disabled: !0, selected: !0, children: p }),
        f
      ] }),
      w && /* @__PURE__ */ l(M, { $filled: s !== p, disabled: a, error: c && !a, children: w }),
      /* @__PURE__ */ h(q, { children: [
        c && !a && /* @__PURE__ */ l(C, { icon: "NegativeLine" }),
        /* @__PURE__ */ l(C, { icon: _ ? "DropdownCloseLine" : "DropdownOpenLine" })
      ] })
    ] }),
    b && /* @__PURE__ */ l(G, { disabled: a, error: c && !a, children: b })
  ] });
});
H.displayName = "RangoInputSelect";
export {
  H as RangoInputSelect
};
